import { Filters } from "@tenforce/product-fields/itemPicker/types"
import { TextCondition } from "@tenforce/product-fields/itemPicker/components/table/filters/types"
import {
    ConditionDTO,
    FiltersDTO,
    TextConditionDTO,
} from "../models/dto/filters"

export const parseFilterDTO = (dto: FiltersDTO): Filters => {
    return (
        dto.Conditions.reduce((acc, condition) => {
            switch (condition["@type"]) {
                case "#TF.TextFieldCondition": {
                    let result: TextCondition = null
                    switch (condition.Operator) {
                        case "Contains": {
                            if (condition.Value) {
                                result = {
                                    type: "TextFieldCondition",
                                    operator: "contains",
                                    value: condition.Value,
                                    isLocked: condition.IsLocked,
                                }
                            }
                            break
                        }
                        case "IsEmpty": {
                            result = {
                                type: "TextFieldCondition",
                                operator: "isEmpty",
                                value: null,
                                isLocked: condition.IsLocked,
                            }
                            break
                        }
                        default:
                            break
                    }
                    if (result && condition.FieldDefinition.Id) {
                        return {
                            ...acc,
                            [condition.FieldDefinition.Id]: result,
                        }
                    }
                    break
                }
                default:
                    return acc
            }
            return acc
        }, {} as Filters) ?? {}
    )
}

export const parseFilters = (filters: Filters): FiltersDTO => {
    return {
        "@type": "#TF.LogicalAnd",
        Conditions: Object.entries(filters)
            .map((entry) => {
                const [id, condition] = entry
                if (!condition) {
                    return
                }
                switch (condition.type) {
                    case "TextFieldCondition": {
                        let result: TextConditionDTO | null = null
                        switch (condition.operator) {
                            case "contains": {
                                if (condition.value) {
                                    result = {
                                        "@type": "#TF.TextFieldCondition",
                                        Operator: "Contains",
                                        Value: condition.value,
                                        IsLocked: condition.isLocked,
                                        FieldDefinition: {
                                            Id: id,
                                        },
                                    }
                                }
                                break
                            }
                            case "isEmpty": {
                                result = {
                                    "@type": "#TF.TextFieldCondition",
                                    Operator: "IsEmpty",
                                    Value: null,
                                    IsLocked: condition.isLocked,
                                    FieldDefinition: {
                                        Id: id,
                                    },
                                }
                                break
                            }
                            default:
                                break
                        }
                        return result
                    }
                    default:
                        break
                }
                return null
            })
            .filter((condition) => condition !== null) as ConditionDTO[],
    }
}

// Filter example:
// {
//     "Filter": {
//         "@type": "#TF.LogicalAnd",
//         "Conditions": [
//              {
//                  "@type": "#TF.TextFieldCondition",
//                  "Operator": "Contains",
//                  "Value": "\"test\"",
//                  "Field":
//                   {
//                      "Label": "LongTextField",
//                      "Code": "txtLongTextField",
//                      "IsActive": true,
//                      "IsFactoryDefault": false,
//                      "Id": "CF7"
//                  }
//             },
//             {
//                 "@type": "#TF.IntegersFieldCondition",
//                 "Operator": "AppearsNotActive",
//                 "Value": [
//                     15,
//                     21,
//                     54
//                 ],
//                 "Field": {
//                     "Label": "Status",
//                     "Code": "Status",
//                     "IsActive": true,
//                     "IsFactoryDefault": true,
//                     "Id": "SF7"
//                 }
//             },
//             {
//                 "@type": "#TF.IntegerFieldCondition",
//                 "Operator": "IsEqualTo",
//                 "Value": 2,
//                 "Field": {
//                     "Label": "Concept",
//                     "Code": "List",
//                     "IsActive": true,
//                     "IsFactoryDefault": true,
//                     "Id": "SF19"
//                 }
//             }
//         ]
//     }
// }
